export default __webpack_public_path__ + "static/media/react.689532e0.jpg";